module.exports = __webpack_public_path__ + "img/barnes-and-noble.3c46575a.png";